import EventBus from 'event_bus'

export default class SaveSearch {
  constructor ($el) {
    this.$el = $el
    if (this.$el.data('save')) {
      this.saveSearch()
    }

    this.addEventHandlers()
  }

  addEventHandlers () {
    this.$el.on('click', this.onClick.bind(this))
  }

  onClick (event) {
    this.saveSearch()
    return false
  }

  saveSearch () {
    const $form = this.$el.parents('form')
    $.ajax({
      method: 'POST',
      url: $form.attr('action'),
      data: $form.serialize()
    }).done((data) => {
      EventBus.trigger('snackbar:message', {
        body: data,
        handlers: []
      })
    })
  }
}
